import { t } from '../../i18n.es.js';
import { styled, SvgIcon } from '@teko/ui';
import React from 'react';
import { OrderStatus } from '../../mobile/OrderItem/OrderItem.es.js';
import { Flex } from '../../mobile/Flex/Flex.es.js';
import { ListItem } from '../../mobile/ListItem/ListItem.es.js';
import { Text } from '../../mobile/Text/Text.es.js';

const Wrapper = styled.div`
  border-radius: 8px;
  border: 1px solid #e4e5f0;
  padding: 4px;
  margin: 16px 16px;
`;
const ShipmentCodAmount = styled.div`
  display: flex;
  align-items: center;
`;
const StyledFlex = styled(Flex)`
  cursor: pointer;
`;
const OrderShipment = ({
  index,
  shipmentCode,
  shipmentId,
  status,
  statusColor,
  onClick,
  codAmount
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    key: index
  }, /* @__PURE__ */ React.createElement(ListItem, {
    title: "",
    left: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Flex, null, /* @__PURE__ */ React.createElement(Text, {
      fontWeight: "500"
    }, t("V\u1EADn \u0111\u01A1n {{index}}{{var0}}", {
      index,
      var0: shipmentCode ? `: ${shipmentCode}` : ""
    })), /* @__PURE__ */ React.createElement(React.Fragment, null, "\xA0"), /* @__PURE__ */ React.createElement(OrderStatus, {
      bgc: statusColor || "#F78212"
    }, status)), /* @__PURE__ */ React.createElement(StyledFlex, {
      alignItems: "center",
      marginTop: "8px",
      onClick: () => onClick == null ? void 0 : onClick(shipmentId)
    }, /* @__PURE__ */ React.createElement(Text, {
      color: "#1990FF"
    }, t("Xem chi ti\u1EBFt v\u1EADn \u0111\u01A1n")), /* @__PURE__ */ React.createElement(React.Fragment, null, "\xA0"), /* @__PURE__ */ React.createElement(SvgIcon, {
      name: "chevron-forward",
      size: 14,
      color: "#1990FF"
    }))),
    right: !!codAmount && /* @__PURE__ */ React.createElement(ShipmentCodAmount, null, /* @__PURE__ */ React.createElement(Text, {
      marginLeft: "auto",
      marginRight: "4px",
      color: "#82869E",
      fontSize: 13
    }, t("C\u1EA7n thanh to\xE1n:")), /* @__PURE__ */ React.createElement(Text, {
      paddingY: "8px",
      fontSize: 16,
      color: "#D60F29",
      fontWeight: "500"
    }, codAmount.toLocaleString("vi-VN", {
      style: "currency",
      currency: "VND"
    })))
  }));
};

export { OrderShipment };
